export default function SectionLocale() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-[#143A66] mb-8 md:mb-10 text-center break-words">
          Réparation de volets roulants à {"{{VILLE}}"} et ses environs
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 min-w-0">
          {/* Colonne gauche — texte */}
          <div className="space-y-5">
            <span className="inline-block bg-[#00B3A4]/10 text-[#00B3A4] text-sm font-semibold px-3 py-1.5 rounded-full">
              Intervention locale
            </span>
            <p className="text-[#2F4A63] text-base leading-relaxed break-words">
              Notre atelier de Strasbourg intervient à {"{{VILLE}}"} et dans les communes voisines — {"{{COMMUNES}}"}. Comptez en moyenne {"{{DELAI}}"} pour un dépannage.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed break-words">
              À {"{{VILLE}}"}, on intervient surtout sur les volets {"{{BATI}}"} : {"{{INTERVENTIONS_FREQUENTES}}"}.
            </p>
          </div>

          {/* Colonne droite — carte blanche */}
          <div className="bg-white rounded-xl border border-[#E2E8F0] p-5 md:p-6">
            <h3 className="text-[#143A66] font-bold text-base mb-4">
              Notre intervention à {"{{VILLE}}"}
            </h3>
            <div className="space-y-4">
              {/* Ligne 1 */}
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                  <i className="ri-map-pin-line text-[#00B3A4] text-sm"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-[#6E869C] text-xs uppercase tracking-wider">Secteur couvert</p>
                  <p className="text-[#2F4A63] text-sm font-medium break-words">{"{{VILLE}}"} + {"{{COMMUNES}}"}</p>
                </div>
              </div>
              {/* Ligne 2 */}
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                  <i className="ri-map-2-line text-[#00B3A4] text-sm"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-[#6E869C] text-xs uppercase tracking-wider">Codes postaux</p>
                  <p className="text-[#2F4A63] text-sm font-medium break-words">{"{{CP}}"}</p>
                </div>
              </div>
              {/* Ligne 3 */}
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                  <i className="ri-time-line text-[#00B3A4] text-sm"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-[#6E869C] text-xs uppercase tracking-wider">Délai moyen</p>
                  <p className="text-[#2F4A63] text-sm font-medium break-words">{"{{DELAI}}"} depuis Strasbourg</p>
                </div>
              </div>
              {/* Ligne 4 */}
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                  <i className="ri-tools-line text-[#00B3A4] text-sm"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-[#6E869C] text-xs uppercase tracking-wider">Volets traités</p>
                  <p className="text-[#2F4A63] text-sm font-medium break-words">PVC, alu, bois — manuels & électriques</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}